const DEFAULT_PROPS = {
    color: '',
    textColor: '',
    position: '',
    timeout: 5000,
    contentClass: ""
};

export default {
    namespaced: true,
    state: {
        isShow: false,
        message: '',
        props: {
            color: '',
            textColor: '',
            position: '',
            timeout: 5000,
            contentClass: ''
        },
    },

    mutations: {
        HIDE(state) {
            state.isShow = false;
            state.message = '';
            state.props = {...DEFAULT_PROPS};
        },
        SHOW(state, payload){
            state.message = payload.message;
            state.props = {...state.props, ...payload};
            state.isShow = true;
        },
        SET_CONTENT_CLASS(state, payload){
            state.props = {...state.props, contentClass: payload};
        },
    },

    getters: {
        IS_SHOW: state => state.isShow,
        COLOR: state => state.props.color,
        MESSAGE: state => state.message,
        TIMEOUT: state => state.props.timeout,
        CONTENT_CLASS: state => state.props.contentClass,
    },  

    actions: {
        SHOW_SUCCESS({commit}, payload){
            commit('SET_CONTENT_CLASS', "indigo--text text--darken-4");
            if(typeof payload === 'string'){
                commit('SHOW', {color: 'success', message: payload});
            }else{
                commit('SHOW', {color: 'success', ...payload});
            }
        },
        SHOW_ERROR({commit}, payload){
            if(typeof payload === 'string'){
                commit('SHOW', {color: 'error', message: payload});
            }else{
                commit('SHOW', {color: 'error', ...payload});
            }
            
        },
        SHOW_RESPONSE_ERROR({dispatch}, payload){
            if(payload.errorResponse.response && payload.errorResponse.response.data){
                let { data } = payload.errorResponse.response;
                if(data.error){
                    dispatch('SHOW_ERROR',data.error);
                    return;
                }
                if(data.message){
                    dispatch('SHOW_ERROR',data.message);
                    return;
                }
            }
            if(payload.defaultError){
                dispatch('SHOW_ERROR', payload.defaultError);
            }
        },
        SHOW_MESSAGE({commit}, payload){
            commit('SHOW', payload);
        },
        CLOSE({commit}){
            commit('HIDE');
        },
    }
}